<template>
  <div class="record-div">
    <div class="record-top">
      <div class="record-num">
        <div class="num-div" @click.prevent="changeNav('today')">
          <div class="div-l">
            <svg-icon icon-class="record1"></svg-icon>
          </div>
          <div :class="visitType=='today'?'div-r check-div-r':'div-r'">
            <div class="r-title">今日访问量</div>
            <div class="r-num">{{formData.todayCount || 0}}</div>
          </div>
        </div>
        <div class="num-div" @click.prevent="changeNav('product')">
          <div class="div-l div-l2">
            <svg-icon icon-class="record2"></svg-icon>
          </div>
          <div :class="visitType=='product'?'div-r check-div-r':'div-r'">
            <div class="r-title">产品访问量</div>
            <div class="r-num">{{formData.productCount || 0}}</div>
          </div>
        </div>
        <div class="num-div" @click.prevent="changeNav('article')">
          <div class="div-l div-l3">
            <svg-icon icon-class="record3"></svg-icon>
          </div>
          <div :class="visitType=='article'?'div-r check-div-r':'div-r'">
            <div class="r-title">文章/图文/视频访问量</div>
            <div class="r-num">{{formData.articleCount ||0}}</div>
          </div>
        </div>
        <div class="num-div" @click.prevent="changeNav('card')">
          <div class="div-l div-l3">
            <svg-icon icon-class="record4"></svg-icon>
          </div>
          <div :class="visitType=='card'?'div-r check-div-r':'div-r'">
            <div class="r-title">名片/签到图片/邀请 访问量</div>
            <div class="r-num">{{formData.cardCount ||0}}</div>
          </div>
        </div>
      </div>
    </div>
    <div class="v-data">
      <ul>
        <li
          :class="checkLi==index?'li-sty li-check-sty':'li-sty'"
          v-for="(item,index) in liList"
          :key="index"
          @click="changLi(item,index)"
        >{{item}}</li>
      </ul>
      <van-pull-refresh v-model="refreshing" @refresh="onRefresh">
        <van-list v-model="loading" :finished="finished" finished-text="没有更多了" @load="onLoad">
          <div
            class="v-info-box"
            v-for="(item,index) in dataList"
            :key="index"
            @click="toDetail(item)"
          >
            <div class="v-title-time">{{item.createTime}}</div>
            <div class="info-div">
              <div class="v-img">
                <img :src="item.headImg" alt />
              </div>
              <div class="v-div">
                <div class="v-info-div">
                  <div class="v-name">{{item.username}}</div>
                  <div class="v-phone">{{item.phoneNo}}</div>
                </div>
                <div class="v-time">{{item.digest}}</div>
              </div>
              <div class="v-right">></div>
              <img class="status-img" :src="checkLi=='0' ? liImg0 : liImg1" alt="">
            </div>
          </div>
        </van-list>
      </van-pull-refresh>
    </div>
  </div>
</template>

<script>
import URLTB from "@/api/apiTB";
import { Toast } from 'vant';
export default {
  data() {
    return {
      formData:{},
      liList: ['未读', '已读'],
      liImg0:require('@/assets/publicImg/status0.png'),
      liImg1:require('@/assets/publicImg/status1.png'),
      checkLi: 0,//绑定未读
      visitType:'today',//绑定今日访问量
      dataList: [],
      page:1,
      size:10,
      loading: false,
      finished: false,
      refreshing: false,
    }
  },
  mounted() {
  },
  methods: {
    onLoad(){
      if (this.visitType=='today') {
        this.gettoday()//今日访问量
      }else if(this.visitType=='product'){
        this.getproduct()//产品访问量
      }else if(this.visitType=='article'){
        this.getarticle()//文章/图文/视频访问量访问量
      }else if(this.visitType=='card'){
        this.getcard()//名片/签到图片/邀请 访问量
      }else if(this.checkLi=='0'){
        this.getunread()//未读数据
      }else if(this.checkLi=='1'){
        this.getread()//已读数据
      }
    },
    onRefresh() {
      this.page=1
      this.dataList=[]
      // 清空列表数据
      this.finished = false;
      // 重新加载数据
      // 将 loading 设置为 true，表示处于加载状态
      this.loading = true;
      this.onLoad();
    },
    gettoday(){//今日访问量
      this.getData()
    },
    getproduct(){//产品访问量
      this.getData()
    },
    getarticle(){//文章/图文/视频访问量访问量
      this.getData()
    },
    getcard(){//名片/签到图片/邀请 访问量
      this.getData()
    },
    getunread(){//未读数据
      this.getData()
    },
    getread(){//已读数据
      this.getData()
    },
    getData() {
      let that=this
      let data = {
        page: that.page,
        size: that.size,
        agentUserId: localStorage.getItem('userid'),// 经济人id
        readStatus: that.checkLi,// 0=未读,1=已读
        visitType: that.visitType// today=今日 ,product=产品 ,article=文章 card=名片
      }
      that.$fetchGet(URLTB.getViews.url, data).then(res => {
        if(res.data.code==20000){
          that.refreshing=false
          that.loading=false
          let list=res.data.data.list.records
          let total=res.data.data.list.total
          that.formData=res.data.data
          if(list==null || list.length<=0){
            // 加载完成
            that.finished=true
            return
          }
          if(that.page>1){
            that.dataList = [...that.dataList ,...list]
          }else{
            that.dataList=list
          }
          if(that.page * that.size >=total){
            that.finished=true
            return
          }
          if(that.page * that.size < total){
            that.page++
          }
          console.log(that.dataList);
        }
      })
    },
    changLi(item,index){//改变是否已读状态
      this.checkLi=index
      if(this.checkLi=='0'){//未读
        this.page=1
        this.dataList=[]
        this.loading=true
        this.finished=false
        this.getunread()
      }else{
        this.page=1
        this.dataList=[]
        this.loading=true
        this.finished=false
        this.getread()
      }
      this.getData()
    },
    changeNav(v){//改变访问量类型
      this.visitType=v
      if (this.visitType=='today') {
        this.page=1
        this.dataList=[]
        this.loading=true
        this.finished=false
        this.gettoday()//今日访问量
      }else if(this.visitType=='product'){
        this.page=1
        this.dataList=[]
        this.loading=true
        this.finished=false
        this.getproduct()//产品访问量
      }else if(this.visitType=='article'){
        this.page=1
        this.dataList=[]
        this.loading=true
        this.finished=false
        this.getarticle()//文章/图文/视频访问量访问量
      }else if(this.visitType=='card'){
        this.page=1
        this.dataList=[]
        this.loading=true
        this.finished=false
        this.getcard()//名片/签到图片/邀请 访问量
      }
    },
    toDetail(item){//详情界面 并改变是否未读状态
      this.$router.push({path:'/clientMaterial',query:{traceId:item.id,userId:item.userId}})
      if(item.readFlag=='0'){
        let data={
          traceId:item.id
        }
        this.$fetchPost(URLTB.changeStatus.url, data).then(res=>{
          console.log(res);
          Toast(res.data.msg)
        })
      }
    }
  }
}
</script>

<style lang="less" scoped>
.record-div {
  height: 100vh;
  overflow: scroll;
  background: #fff;
  font-family: Source Han Sans CN;
  .record-top {
    width: 375px;
    height: 220px;
    background: url("./img/bg.png") no-repeat 100%;
    background-size: 100% 100%;
    overflow: hidden;
    .record-num {
      width: 355px;
      margin: 8px auto auto;
      display: flex;
      flex-wrap: wrap;
      overflow: hidden;
      color: #333333;
      .num-div:nth-child(2n) {
        margin-left: 9px;
      }
      .num-div {
        width: 173px;
        height: 72px;
        margin-top: 7px;
        display: flex;
        align-items: center;
        background: url("./img/bg1.png") no-repeat 100%;
        background-size: 100% 100%;
        .div-l {
          // width: 60px;
          margin: 0 10px;
          text-align: center;
          align-items: center;
          .svg-icon {
            width: 39px;
            height: 36px;
          }
        }
        .div-l2 {
          .svg-icon {
            width: 30px;
            height: 34px;
          }
        }
        .div-l3 {
          .svg-icon {
            width: 36px;
            height: 35px;
          }
        }
        .div-r {
          // width: 113px;
          font-weight: 400;
          .r-title {
            font-size: 12px;
          }
          .r-num {
            font-size: 18px;
            font-weight: bold;
          }
        }
        .check-div-r{
          color: #FC6E09;
        }
      }
    }
  }
  .v-data {
    width: 355px;
    margin: 15px auto auto;
    font-weight: 400;
    font-size: 11px;
    color: #666666;
    img {
      width: 100%;
      border-radius: 50%;
    }
    ul {
      display: flex;
      .li-sty {
        width: 45px;
        height: 20px;
        line-height: 20px;
        text-align: center;
        font-size: 11px;
        font-weight: 400;
        color: #999999;
        background: url("../../assets/publicImg/li-bg6.png") no-repeat 100%;
        background-size: 100% 100%;
        &:last-child {
          margin-left: 5px;
        }
      }
      .li-check-sty {
        font-weight: 500;
        color: #ffffff;
        background: url("../../assets/publicImg/li-bg2.png") no-repeat 100%;
        background-size: 100% 100%;
      }
    }
    .v-info-box {
      padding: 0 10px;
      margin-top: 7px;
      // border-bottom: 1px solid #ededed;
      background: url("../../assets/publicImg/con-bg.png") no-repeat 100%;
      background-size: 100% 100%;
      border: 1px solid transparent;
      position: relative;
      .v-title-time {
        margin: 10px 0;
      }
      .info-div {
        // align-items: center;
        height: 40px;
        display: flex;
        margin-bottom: 10px;
        .v-img {
          width: 40px;
          height: 40px;
        }
        .v-div {
          margin-left: 25px;
          .v-info-div{
            display: flex;
            .v-name {
              margin-bottom: 5px;
              font-weight: 500;
              font-size: 12px;
              color: #333333;
            }
            .v-phone{
              padding-left: 40px;
            }
          }
          .v-time {
          }
        }
        .v-right {
          position: absolute;
          right: 16px;
          top: 50%;
          transform: translateY(-50%);
          color: #d4d4d4;
        }
        .status-img{
          width: 13px;
          height: 13px;
          position: absolute;
          top: 15px;
          right: 15px;
        }
      }
    }
  }
}
</style>